export default __webpack_public_path__ + "static/delivery-feature_tablet_kz-30b0f41b7fd95256e4664109de08efe4.png";